import React from "react";
import Typewriter from "typewriter-effect";

const Type = () => {
  return (
    <Typewriter
      options={{
        strings: [
          "Full Stack Developer",
          "Next.js & MERN Stack Engineer",
          "Shopify App & Theme Developer",
          "Building Scalable Web Applications",
        ],
        autoStart: true,
        loop: true,
        delay: 60, // typing speed
        deleteSpeed: 40, // backspace speed
        pauseFor: 1500, // pause before deleting
      }}
    />
  );
};

export default Type;
